






























import { Component, Mixins, Prop } from 'vue-property-decorator'
import { mapState, mapGetters } from 'vuex'
import WithBuilderSubscriptionConfig from '@/mixins/WithBuilderSubscriptionConfig'
import BuilderTooltip from '@/components/builder/BuilderTooltip.vue'
import BuilderButton from '@/components/builder/BuilderButton.vue'
import BuilderSubscriptionModal, { Subscription as ViewSubscription } from '@/components/builder/BuilderSubscriptionModal.vue'
import BuilderAddButton from '@/components/builder/BuilderAddButton.vue'
import { ProfileStubState } from './BuilderProfile.vue'
import BuilderDot from '@/components/builder/BuilderDot.vue'

@Component({
  components: {
    BuilderAddButton,
    BuilderSubscriptionModal,
    BuilderButton,
    BuilderTooltip,
    BuilderDot,
  },
  computed: {
    ...mapState('builder', ['app', 'promotionalPage']),
    ...mapGetters('builder', { appType: 'getAppType' }),
  },
})
export default class BuilderProfileFollowers extends Mixins(WithBuilderSubscriptionConfig) {
  @Prop({ required: true, type: Object }) readonly value!: ProfileStubState

  @Prop({ required: true, type: Number }) readonly step!: number

  processing = false

  open = false

  promotionalPage: any

  app: any

  promoPageName = ''

  appType!: string

  get subscriptions(): ViewSubscription[] {
    const frequencyDefault = [2, 3, 5]
    return this.value.subscriptions.length
      ? this.value.subscriptions
      : Array.from(new Array(3)).map((_, i) => ({
          id: -i - i,
          name: `${i + 1}`,
          price: '',
          frequency: frequencyDefault[i],
          duration: 1,
        }))
  }

  set subscriptions(value: ViewSubscription[]) {
    this.$emit('input', { subscriptions: value })
  }

  get isNextStepDisabled(): boolean {
    return (
      !this.subscriptions.length ||
      !this.subscriptions.every((s) => Number(s.price) > 0 && this.promoPageName.length) ||
      !this.subscriptions.every((item) => {
        return Number(item.price) >= (this.app.currency.code === 'RUB' ? 100 : 7)
      })
    )
  }

  get payloadTariffsPromotionalPage(): string[] {
    return this.app.tariffs.map((item) => `api/tariffs/${item.id}`)
  }

  async onNextClick(): Promise<void> {
    this.processing = true

    try {
      await this.$store.dispatch('builder/setProfileSubscriptions', {
        subscriptions: this.subscriptions,
        name: this.promoPageName,
      })

      if (this.promotionalPage?.id) {
        await this.$store.dispatch('builder/updatePromotionalPage', {
          tariffs: this.payloadTariffsPromotionalPage,
          id: this.promotionalPage.id,
          name: this.promoPageName,
        })
      } else {
        await this.$store.dispatch('builder/createPromotionalPage', {
          app: `api/apps/${this.app.id}`,
          status: 1,
          designType: 1,
          tariffs: this.payloadTariffsPromotionalPage,
          name: this.promoPageName,
        })
      }

      this.$emit('next')
    } catch (e: any) {
      this.$toasted.error(e.message)
    }

    this.processing = false
  }

  setPromoPageName(name: string) {
    this.promoPageName = name
  }

  created(): void {
    if (this.appType === 'TYPE_STORE') {
      this.$emit('next')
    }
  }

  async mounted(): Promise<void> {
    if (this.promotionalPage) {
      this.promoPageName = this.promotionalPage.name
    }
    this.$emit('input', {
      highlight: 'subscriptions',
      blurProfile: false,
      blurCover: false,
      blurContentType: true,
      blurPosts: true,
    })
  }
}
